export const ReferralBonusMap = {
    CREATE_REFERRAL_BONUS_START: 'CREATE_REFERRAL_BONUS_START',
    CREATE_REFERRAL_BONUS_SUCCESS: 'CREATE_REFERRAL_BONUS_SUCCESS',
    CREATE_REFERRAL_BONUS_ERROR: 'CREATE_REFERRAL_BONUS_ERROR',

    GET_ALL_REFERRAL_BONUS_START: 'GET_ALL_REFERRAL_BONUS_START',
    GET_ALL_REFERRAL_BONUS_SUCCESS: 'GET_ALL_REFERRAL_BONUS_SUCCESS',
    GET_ALL_REFERRAL_BONUS_ERROR: 'GET_ALL_REFERRAL_BONUS_ERROR',

    UPDATE_REFERRAL_BONUS_START: 'UPDATE_REFERRAL_BONUS_START',
    UPDATE_REFERRAL_BONUS_SUCCESS: 'UPDATE_REFERRAL_BONUS_SUCCESS',
    UPDATE_REFERRAL_BONUS_ERROR: 'UPDATE_REFERRAL_BONUS_ERROR',

    SET_SELECTED_REFERRAL_BONUS: 'SET_SELECTED_REFERRAL_BONUS',

    REFRESH_REFERRAL_BONUS_LIST: 'REFRESH_REFERRAL_BONUS_LIST',
}

export const ReferralBonusActions = {
    getAllReferralBonusStart: (data) => ({ type: ReferralBonusMap.GET_ALL_REFERRAL_BONUS_START, payload: data }),
    getAllReferralBonusSuccess: (data) => ({ type: ReferralBonusMap.GET_ALL_REFERRAL_BONUS_SUCCESS, payload: data }),
    getAllReferralBonusError: () => ({ type: ReferralBonusMap.GET_ALL_REFERRAL_BONUS_ERROR }),

    createReferralBonusStart: () => ({ type: ReferralBonusMap.CREATE_REFERRAL_BONUS_START }),
    createReferralBonusSuccess: (data) => ({ type: ReferralBonusMap.CREATE_REFERRAL_BONUS_SUCCESS, payload: data }),
    createReferralBonusError: (errors) => ({ type: ReferralBonusMap.CREATE_REFERRAL_BONUS_ERROR, payload: { errors } }),

    updateReferralBonusStart: () => ({ type: ReferralBonusMap.UPDATE_REFERRAL_BONUS_START }),
    updateReferralBonusSuccess: (data) => ({ type: ReferralBonusMap.UPDATE_REFERRAL_BONUS_SUCCESS, payload: data }),
    updateReferralBonusError: (errors) => ({ type: ReferralBonusMap.UPDATE_REFERRAL_BONUS_ERROR, payload: { errors } }),

    setSelectedReferralBonus: (data) => ({ type: ReferralBonusMap.SET_SELECTED_REFERRAL_BONUS, payload: data }),

    refreshReferralBonusList: () => ({ type: ReferralBonusMap.REFRESH_REFERRAL_BONUS_LIST }),
} 